type LinkCard = {
  fields: readonly unknown[]
  submitTargetUrl?: string | null
}

const isLinkOnlyCard = ({ fields, submitTargetUrl }: LinkCard) =>
  fields.length === 0 && !!submitTargetUrl?.trim()

const hasLabelledFields = (fields: ReadonlyArray<{ label: string }>) =>
  fields.some((field) => field.label.trim() !== '')

export { isLinkOnlyCard, hasLabelledFields }
